import { api, setToken, clearToken } from "../src/lib/client/api.js";
import { t } from "../src/lib/client/i18n.js";

<let/view="login">
<let/email="">
<let/password="">
<let/displayName="">
<let/resetToken="">
<let/busy=false>
<let/notice="">
<let/noticeTone="info">
<let/error="">
<let/booted=false>

<script>
  if (!booted && typeof window !== "undefined") {
    booted = true;
    const params = new URLSearchParams(window.location.search);
    const verified = params.get("verified");
    const reset = params.get("reset");
    const viewParam = params.get("view");
    email = params.get("email") || "";

    if (reset === "1" && params.get("token")) {
      view = "reset";
      resetToken = params.get("token") || "";
    } else if (reset === "0") {
      notice = t("auth.resetInvalid");
      noticeTone = "warn";
    } else if (verified === "1") {
      notice = t("auth.verifiedSuccess");
      noticeTone = "success";
    } else if (verified === "0") {
      notice = t("auth.verifiedFailed");
      noticeTone = "warn";
    } else if (viewParam === "signup") {
      view = "signup";
    }
  }
</script>

<div class="auth-screen">
  <div class="auth-screen__glow" aria-hidden="true"/>
  <div class="auth-card">
    <div class="auth-card__brand">
      <div class="auth-card__mark" aria-hidden="true">
        <img src="/assets/tiles/modern/logo.svg" alt="" width="64" height="64">
      </div>
      <h1 class="auth-card__title">${t("brand.name")}</h1>
      <p class="auth-card__tagline">${t("brand.tagline")}</p>
    </div>

    <if=notice>
      <div class=["auth-notice", noticeTone === "success" && "auth-notice--success", noticeTone === "warn" && "auth-notice--warn"] role="status">
        ${notice}
      </div>
    </if>
    <if=error>
      <div class="auth-notice auth-notice--warn" role="alert">${error}</div>
    </if>

    <if=(view === "login")>
      <h2 class="auth-card__heading">${t("auth.loginTitle")}</h2>
      <p class="auth-card__lede">${t("auth.loginLede")}</p>
      <form
        class="auth-form"
        onSubmit(e) {
          e.preventDefault();
          if (busy) return;
          busy = true;
          error = "";
          api.login({ email, password })
            .then((data) => {
              setToken(data.token);
              window.location.href = "/app";
            })
            .catch((err) => {
              error = err.message || t("auth.errorGeneric");
              busy = false;
            });
        }
      >
        <label class="field">
          <span>${t("auth.emailLabel")}</span>
          <input type="email" autocomplete="email" required value:=email placeholder=t("auth.emailPlaceholder")>
        </label>
        <label class="field">
          <span>${t("auth.passwordLabel")}</span>
          <input type="password" autocomplete="current-password" required value:=password placeholder=t("auth.passwordPlaceholder") minlength=8>
        </label>
        <button type="submit" class="btn btn--primary btn--block" disabled=busy>
          ${busy ? t("auth.signingIn") : t("auth.signIn")}
        </button>
      </form>
      <div class="auth-links">
        <button type="button" class="auth-link" onClick() { view = "forgot"; error = ""; notice = ""; }>
          ${t("auth.forgotLink")}
        </button>
        <p>
          ${`${t("auth.needAccount").trimEnd()} `}<button type="button" class="auth-link" onClick() { view = "signup"; error = ""; notice = ""; }>${t("auth.createAccountLink")}</button>
        </p>
      </div>
    </if>

    <else if=(view === "signup")>
      <h2 class="auth-card__heading">${t("auth.signupTitle")}</h2>
      <p class="auth-card__lede">${t("auth.signupLede")}</p>
      <form
        class="auth-form"
        onSubmit(e) {
          e.preventDefault();
          if (busy) return;
          busy = true;
          error = "";
          api.signup({ email, password, displayName })
            .then(() => {
              notice = t("auth.signupSuccess");
              noticeTone = "success";
              view = "login";
              password = "";
              busy = false;
            })
            .catch((err) => {
              error = err.message || t("auth.errorGeneric");
              busy = false;
            });
        }
      >
        <label class="field">
          <span>${t("auth.emailLabel")}</span>
          <input type="email" autocomplete="email" required value:=email placeholder=t("auth.emailPlaceholder")>
        </label>
        <label class="field">
          <span>${t("auth.displayNameLabel")} <em>${t("auth.displayNameOptional")}</em></span>
          <input type="text" autocomplete="name" value:=displayName placeholder=t("auth.displayNamePlaceholder")>
        </label>
        <label class="field">
          <span>${t("auth.passwordLabel")}</span>
          <input type="password" autocomplete="new-password" required value:=password placeholder=t("auth.passwordPlaceholder") minlength=8>
        </label>
        <button type="submit" class="btn btn--primary btn--block" disabled=busy>
          ${busy ? t("auth.creating") : t("auth.createAccount")}
        </button>
      </form>
      <div class="auth-links">
        <p>
          ${`${t("auth.haveAccount").trimEnd()} `}<button type="button" class="auth-link" onClick() { view = "login"; error = ""; }>${t("auth.signInLink")}</button>
        </p>
      </div>
    </else>

    <else if=(view === "forgot")>
      <h2 class="auth-card__heading">${t("auth.forgotTitle")}</h2>
      <p class="auth-card__lede">${t("auth.forgotLede")}</p>
      <form
        class="auth-form"
        onSubmit(e) {
          e.preventDefault();
          if (busy) return;
          busy = true;
          error = "";
          api.forgotPassword({ email })
            .then(() => {
              notice = t("auth.resetSent");
              noticeTone = "success";
              view = "login";
              busy = false;
            })
            .catch((err) => {
              error = err.message || t("auth.errorGeneric");
              busy = false;
            });
        }
      >
        <label class="field">
          <span>${t("auth.emailLabel")}</span>
          <input type="email" autocomplete="email" required value:=email placeholder=t("auth.emailPlaceholder")>
        </label>
        <button type="submit" class="btn btn--primary btn--block" disabled=busy>
          ${busy ? t("auth.sending") : t("auth.sendResetLink")}
        </button>
      </form>
      <div class="auth-links">
        <button type="button" class="auth-link" onClick() { view = "login"; error = ""; }>
          ${t("auth.backToSignIn")}
        </button>
      </div>
    </else>

    <else if=(view === "reset")>
      <h2 class="auth-card__heading">${t("auth.resetTitle")}</h2>
      <p class="auth-card__lede">${t("auth.resetLede")}</p>
      <form
        class="auth-form"
        onSubmit(e) {
          e.preventDefault();
          if (busy) return;
          busy = true;
          error = "";
          api.resetPassword({ token: resetToken, password })
            .then((data) => {
              clearToken();
              notice = t("auth.passwordResetSuccess");
              noticeTone = "success";
              if (data.email) email = data.email;
              password = "";
              view = "login";
              busy = false;
            })
            .catch((err) => {
              error = err.message || t("auth.errorGeneric");
              busy = false;
            });
        }
      >
        <label class="field">
          <span>${t("auth.passwordLabel")}</span>
          <input type="password" autocomplete="new-password" required value:=password placeholder=t("auth.passwordPlaceholder") minlength=8>
        </label>
        <button type="submit" class="btn btn--primary btn--block" disabled=busy>
          ${busy ? t("auth.saving") : t("auth.savePassword")}
        </button>
      </form>
      <div class="auth-links">
        <button type="button" class="auth-link" onClick() { view = "login"; error = ""; }>
          ${t("auth.backToSignIn")}
        </button>
      </div>
    </else>
  </div>
</div>
